import { motion } from 'framer-motion';
import { Sparkles, Mail, MapPin } from 'lucide-react';
import siteConfig from '@/config/siteConfig';

export const Footer = () => {
  return (
    <footer className="bg-background border-t border-border/30">
      {/* Main Footer */}
      <div className="container-luxury py-16">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Logo & Description */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-accent to-accent-dark flex items-center justify-center shadow-gold">
                <Sparkles className="w-5 h-5 text-background" />
              </div>
              <span className="font-display text-lg text-foreground">
                Maîtres <span className="text-gradient-gold">Dauphins</span>
              </span>
            </div>
            <p className="text-muted-foreground font-body text-sm leading-relaxed">
              Un chemin pour vibrer plus fort, aimer ta vie… et, si tu le choisis, 
              transmettre cette fréquence.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display text-lg text-foreground mb-6">Contact</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-accent shrink-0 mt-0.5" />
                <p className="text-muted-foreground font-body text-sm">
                  Delieuze Gilles, Espace Asanoha<br />
                  7 Rue de l'Église 11200 Ornaisons
                </p>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-accent" />
                <a 
                  href={`mailto:${siteConfig.email}`}
                  className="text-muted-foreground font-body text-sm hover:text-accent transition-colors"
                >
                  {siteConfig.email}
                </a>
              </div>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-display text-lg text-foreground mb-6">Légalité</h4>
            <div className="space-y-3">
              <a 
                href={siteConfig.privacyLink} 
                target="_blank" 
                rel="noopener noreferrer"
                className="block text-muted-foreground font-body text-sm hover:text-accent transition-colors"
              >
                Politique de confidentialité
              </a>
              <a 
                href={siteConfig.termsLink} 
                target="_blank" 
                rel="noopener noreferrer"
                className="block text-muted-foreground font-body text-sm hover:text-accent transition-colors"
              >
                Conditions générales de vente
              </a>
              <a 
                href={siteConfig.legalLink} 
                target="_blank" 
                rel="noopener noreferrer"
                className="block text-muted-foreground font-body text-sm hover:text-accent transition-colors"
              >
                Mentions légales
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-border/30">
        <div className="container-luxury py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-muted-foreground font-body text-sm text-center md:text-left">
              © 2024-2027 GILLES DELIEUZE Tous droits réservés
            </p>
            <p className="text-muted-foreground/60 font-body text-xs text-center max-w-xl">
              Ce site ne fait pas partie du site YouTube™️, Google™️, Facebook™️, Google Inc. ou Facebook Inc.
            </p>
          </div>
        </div>
      </div>

      {/* Decorative dolphin image */}
      <div className="relative h-32 overflow-hidden">
        <motion.img
          src="https://gillesdelieuze.com/wp-content/uploads/2024/08/gilles1385_dolphins_galactica_bright_colors_joy_turquoise_photo_fd93484f-89cd-4eac-b620-a1845d635b21-1024x650.png"
          alt="Dauphins"
          className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-auto opacity-20"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 0.2 }}
          transition={{ duration: 1 }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/80 to-transparent" />
      </div>
    </footer>
  );
};

export default Footer;
